import { projectDetailQuery } from '@/api/finance.js';

const state = {
  projectId: null,
  detail: {},
  latest: [],
  events: [],
  invest: [],
  exit: [],
  unrealized: [],
  realized: [],
  history: [],
  tianchiProjectId: [],
  projectStatus: [],
  investEffectDateMap: {},
  exitEffectDateMap: {},
  valueEffectDate: null
};

const mutations = {
  setDetail: (state, res) => {
    let { data = {} } = res || {};
    let { detail, latest, events, invest, exit, unrealized, realized, history, tianchiProjectId, projectStatus } = data;
    state.latest = [latest];
    state.detail = detail;
    state.events = events;
    state.invest = invest;
    state.exit = exit;
    state.realized = realized;
    state.unrealized = unrealized;
    state.history = history;
    state.tianchiProjectId = tianchiProjectId;
    state.projectStatus = projectStatus;
    state.valueEffectDate = latest.effectDate;
    state.investEffectDateMap = invest.reduce((map, item) => {
      map[item.dealId] = item.effectDate;
      return map;
    }, {});
    state.exitEffectDateMap = exit.reduce((map, item) => {
      map[item.dealId] = item.effectDate;
      return map;
    }, {});
  },
  setProjectId: (state, projectId) => {
    state.projectId = projectId;
  }
};

const actions = {
  async fetchDetail({ commit, state }) {
    let { projectId } = state;
    let res = await projectDetailQuery({ projectId });
    commit('setDetail', res);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
